document.addEventListener("Searchanise.Loaded", function () {
  (function ($) {
    $(document).on("Searchanise.AddToCartSuccess", function () {
      if (window.CCart && window.CCart.buildCart) {
        window.CCart.getCart(window.CCart.buildCart);
      }

      if (window.CCart && window.CCart.popover && window.CCart.popover.show) {
        $.getJSON('/cart.js', function(data) {
          window.CCart.popover.show(data.items[0]);
        });
      }
    });
  })(window.Searchanise.$);
});